import React from 'react';
import { Translate } from 'core/translate';
import MathBoxGroup from './MathBoxGroup';

export const FamilyFirstIneligibleTrimMessage = ({
  eligibleForInvoicePrice,
}) => {
  if (eligibleForInvoicePrice) {
    return null;
  }

  return (
    <MathBoxGroup className="ineligible-family-first-message">
      <Translate value="byo.page.ineligible.trim" />
    </MathBoxGroup>
  );
};

export default FamilyFirstIneligibleTrimMessage;
